/* eslint-disable @typescript-eslint/no-empty-function */
import * as React from 'react';
import NavigationService from 'services/NavigationService';
const NavigationContext = React.createContext(new NavigationService({
    setAppView: () => { }, setAvailableTabs: () => { }, setTab: () => { }, setView: () => { },
}));
export default NavigationContext;
